var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g, _g2, _path50, _path51, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 87,
    viewBox: "0 0 130 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 62.4676L17.2392 26.4053L17.6498 24.5996L60.2483 34.5567L91.966 40.077L106.08 59.6138L101.666 58.6499L120.091 62.674V84.3939L92.3254 86.1996L66.561 85.3226L38.5898 86.1996L31.0452 85.3226L29.0436 84.6519H21.4477H18.7789L7.89832 83.5169V76.3457L7.23111 75.4686V74.7979L7.89832 74.3336V69.8452H6.7692V62.4676H5.69141Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.252 26.4673L34.0416 56.2425L66.1567 59.9218V58.9396L34.5065 54.7951L17.7686 25.2783L17.252 26.4673Z",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5589 54.7949L34.1973 56.2423",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.09 59.2408L92.6249 39.3389L17.6657 24.5029L5.57715 61.7219H7.02364L18.1823 28.0698",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M37.5546 63.5312L66.1569 65.8532L66.4148 83.9053L37.5546 84.6737L29.4956 83.7949H27.6875V64.6168H29.4956L37.5546 63.5312Z",
    fill: "#B1D6DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.883 61.981L92.3668 56.1914L66.415 58.8909V60.7002V83.962",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02344 61.7217V69.1138H10.227V73.9212H7.02344V74.5933L7.54004 75.2136V78.7545V82.7609",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54004 82.2962L16.064 82.9166L18.1304 82.6581L27.6876 83.692L29.1857 83.4852L37.9164 84.1572L67.6211 83.5369L92.3664 84.9843L120.676 82.6064V61.5156",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90137 69.3213V73.922",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2713 82.916L16.168 46.3173L24.8469 43.1123V62.1354L17.6661 62.6523L17.8728 82.6575",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2998 44.7666V62.4456",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.541 44.3535V62.4461",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8838 62.0835V45.8001L24.8469 45.2832",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3007 46.6279L18.6992 47.2999L18.9059 62.446",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.584 83.3297V64.4617L29.1855 64.6168L37.0895 63.5312L66.1562 65.8532V83.6474",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2441 56.915V63.5318",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8535 64.6172V83.7436",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M70.5411 65.3379H66.9307V81.1206L70.5411 81.3269V65.3379Z",
    fill: "#B1D6DE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1748 64.0479V84.0014",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8154 64.8213V84.1545",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M81.8271 81.8309V64.6171L86.5799 64.5654V82.0377L81.8271 81.8309Z",
    fill: "#B1D6DE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6543 64.9268V83.9498",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.709 65.3379V84.2059",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3672 56.1914V84.9845",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9307 65.3379H70.5411V81.3269L66.9307 81.2755",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5879 64.6688V81.7275L86.6838 81.9859V64.5137L80.5879 64.6688Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9316 64.6172V81.7793",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M101.718 81.1582V65.5469L116.493 67.0977V80.2794L101.718 81.1582Z",
    fill: "#B1D6DE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.769 64.3066V81.3137L117.938 80.3832V66.1676L101.769 64.3066Z",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.872 65.3926L116.492 66.9434L117.938 66.1163",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M116.492 67.0986V80.2804",
    stroke: "#8FA1AC",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.92 65.8057V81.0034",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.311 66.2715V80.8489",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M113.082 66.6846V80.5383",
    stroke: "#8FA1AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4072 26.5195L34.1969 56.1914",
    stroke: "#8FA1AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M18.75 62.3943V47.2482L18.9566 47.0414L20.2998 46.5762V62.3943H18.75Z",
    fill: "#B1D6DE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M22.9863 62.187V45.9037L24.7944 45.4385V62.187H22.9863Z",
    fill: "#B1D6DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M61.2672 67.3047L41.3779 77.1264V78.6772L61.2672 67.3047Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.234 71.1299L104.61 76.9195V77.85L116.234 71.1299Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.3521 70.665L42.4629 80.4867V82.0375L62.3521 70.665Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M116.699 72.8877L105.075 78.6773V79.6078L116.699 72.8877Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4912 60.2892L92.6066 58.2002L120.091 63.0002",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M24.8916 26.2002L37.3332 48.0115L89.6916 53.4002L77.9601 36.8566L24.8916 26.2002Z",
    fill: "#8FA1AC"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.362 83.3692H122.203L93.9997 86.2L69.3471 84.4769L39.7538 85.2154L31.0559 84.4154L29.5634 84.6615L20.0421 83.4308L17.9834 83.7385L9.49139 83H1",
    stroke: "#8FA1AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2602 15.0057C27.9411 14.9538 27.6753 15.2651 27.8348 15.5244L35.6517 30.0483L42.5114 42.7567C42.6177 43.0161 42.8836 43.1717 43.1495 43.1717L94.4112 49.5518C94.7302 49.6037 94.9429 49.2406 94.7834 48.9812L79.0602 24.747C79.0602 24.747 78.9006 24.5914 78.7943 24.5914L28.2602 15.0057Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M41.916 17.6289L56.6156 44.707",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M55.3262 20.207L70.0257 46.7694",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M67.9629 22.5283L82.9203 48.8328",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M34.9531 28.2021L86.2726 36.1966",
    stroke: "white",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.054 2C82.1876 2 75 9.18765 75 18.0541C75 22.3625 76.6972 26.2745 79.4595 29.1581V37.2295L85.3424 33.0624C87.117 33.7381 89.0423 34.1081 91.054 34.1081H91.946C100.812 34.1081 108 26.9205 108 18.0541C108 9.18765 100.812 2 91.946 2H91.054Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.054 2C82.1876 2 75 9.18765 75 18.0541C75 22.3625 76.6972 26.2745 79.4595 29.1581V37.2295L85.3424 33.0624C87.117 33.7381 89.0423 34.1081 91.054 34.1081H91.946C100.812 34.1081 108 26.9205 108 18.0541C108 9.18765 100.812 2 91.946 2H91.054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4595 29.1581H80.4595V28.7564L80.1816 28.4663L79.4595 29.1581ZM79.4595 37.2295H78.4595V39.1633L80.0375 38.0455L79.4595 37.2295ZM85.3424 33.0624L85.6983 32.1278L85.1998 31.938L84.7644 32.2463L85.3424 33.0624ZM76 18.0541C76 9.73993 82.7399 3 91.054 3V1C81.6354 1 74 8.63536 74 18.0541H76ZM80.1816 28.4663C77.5905 25.7615 76 22.0945 76 18.0541H74C74 22.6304 75.8039 26.7876 78.7374 29.8498L80.1816 28.4663ZM80.4595 37.2295V29.1581H78.4595V37.2295H80.4595ZM84.7644 32.2463L78.8815 36.4134L80.0375 38.0455L85.9205 33.8784L84.7644 32.2463ZM91.054 33.1081C89.1658 33.1081 87.361 32.7609 85.6983 32.1278L84.9866 33.9969C86.873 34.7152 88.9188 35.1081 91.054 35.1081V33.1081ZM91.946 33.1081H91.054V35.1081H91.946V33.1081ZM107 18.0541C107 26.3682 100.26 33.1081 91.946 33.1081V35.1081C101.365 35.1081 109 27.4727 109 18.0541H107ZM91.946 3C100.26 3 107 9.73993 107 18.0541H109C109 8.63536 101.365 1 91.946 1V3ZM91.054 3H91.946V1H91.054V3Z",
    fill: "#E6E6E6",
    mask: "url(#path-50-inside-1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6322 24.8595C92.8847 24.1808 92.5952 23.4027 91.9857 23.1216C91.3762 22.8405 90.6774 23.1628 90.4249 23.8415C90.1724 24.5201 90.4619 25.2982 91.0714 25.5793C91.6809 25.8605 92.3797 25.5382 92.6322 24.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0556 21.6677C95.377 21.2004 95.2979 20.5273 94.8757 20.1694C94.029 19.4483 93.0167 19.029 91.9469 18.9569C90.5245 18.8634 89.15 19.3922 88.0826 20.4472C87.6868 20.8398 87.6509 21.5155 88.0035 21.9562C88.193 22.1939 88.4568 22.3141 88.7207 22.3141C88.9462 22.3141 89.174 22.2259 89.3587 22.0443C90.0424 21.3686 90.9227 21.0267 91.8342 21.0882C92.5202 21.1336 93.1678 21.4007 93.71 21.8627C94.1321 22.2233 94.7342 22.1351 95.0556 21.6677Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7195 18.8471C98.0721 18.4064 98.0385 17.7334 97.6451 17.3381C95.978 15.6768 93.8264 14.7607 91.586 14.7607C89.2833 14.7607 87.0885 15.7196 85.4022 17.4636C85.0136 17.8642 84.992 18.54 85.3518 18.9726C85.5413 19.1997 85.798 19.3145 86.0546 19.3145C86.2873 19.3145 86.5224 19.221 86.7071 19.0287C88.0359 17.6532 89.7702 16.8974 91.586 16.8974C93.3538 16.8974 95.0497 17.6185 96.3666 18.9299C96.76 19.3252 97.3644 19.2851 97.7195 18.8471Z",
    fill: "#F26829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5856 10.3242C88.2274 10.3242 85.0372 11.7398 82.6001 14.3064C82.2163 14.7124 82.1995 15.3881 82.5617 15.8181C82.7512 16.0398 83.0055 16.152 83.2597 16.152C83.4972 16.152 83.7347 16.0558 83.9194 15.8608C85.999 13.6681 88.7216 12.4609 91.5856 12.4609C94.3969 12.4609 97.081 13.628 99.1463 15.7487C99.5348 16.1493 100.142 16.1199 100.502 15.6872C100.861 15.2546 100.835 14.5762 100.446 14.1782C98.0261 11.6917 94.879 10.3242 91.5856 10.3242Z",
    fill: "#F26829"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6447 13.5791L93.6547 13.5183V13.4568C93.6547 12.1781 92.7735 10.8877 91.4016 10.8877C90.0296 10.8877 89.1484 12.1781 89.1484 13.4568V13.5183L89.1585 13.579L90.1991 19.8758C90.1991 19.8758 90.1991 19.8758 90.1991 19.8759C90.3012 20.494 90.7802 20.9625 91.4015 20.9625C92.0228 20.9625 92.5018 20.4941 92.6039 19.8759C92.6039 19.8759 92.6039 19.8758 92.6039 19.8758L93.6447 13.5791Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4685 25.3835C92.5776 25.3835 93.2457 24.351 93.2457 23.3905C93.2457 22.43 92.5776 21.3975 91.4685 21.3975C90.3595 21.3975 89.6914 22.43 89.6914 23.3905C89.6914 24.351 90.3595 25.3835 91.4685 25.3835Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 73,
    y: 0,
    width: 41,
    height: 43.2295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12625 0 0 0 0 0.2583 0 0 0 0 0.3 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseError);
export default __webpack_public_path__ + "static/media/house-error.5ad51078550e89d2dc47881dbda1f9e8.svg";
export { ForwardRef as ReactComponent };